import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiClient } from '../api'
import type { EventBriefingDoc } from '../types'

// Product Briefing content (Feature 1). One editable doc per event.

export function useBriefingDoc(eventId: number) {
  return useQuery({
    queryKey: ['briefing-doc', eventId],
    queryFn: () => ApiClient.briefingDoc(eventId),
    enabled: Number.isFinite(eventId) && eventId > 0
  })
}

export function useUpdateBriefingDoc(eventId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: EventBriefingDoc) => ApiClient.putBriefingDoc(eventId, body),
    onSuccess: (saved: EventBriefingDoc) => {
      qc.setQueryData(['briefing-doc', eventId], saved)
    }
  })
}
